import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { LanguageProvider } from './contexts/LanguageContext';
import { Layout } from './components/Layout';
import { Toaster } from './components/ui/sonner';
import { AnalyticsListener } from './components/AnalyticsListener';

// Pages
import { HomePage } from './pages/HomePage';
import { EnergyPotentialPage } from './pages/EnergyPotentialPage';
import { ContactPage } from './pages/ContactPage';
import { AdminLeadsPage } from './pages/AdminLeadsPage';

import './App.css';

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <BrowserRouter>
          <AnalyticsListener />
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/potencial-energetico" element={<EnergyPotentialPage />} />
              <Route path="/contacto" element={<ContactPage />} />
              <Route path="/admin/leads" element={<AdminLeadsPage />} />
            </Routes>
          </Layout>
          <Toaster />
        </BrowserRouter>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;